import script from "./sign.in.vue?vue&type=script&setup=true&lang=js"
export * from "./sign.in.vue?vue&type=script&setup=true&lang=js"

import "./sign.in.vue?vue&type=style&index=0&id=31f7aaea&lang=less"

const __exports__ = script;

export default __exports__